module.exports = __webpack_public_path__ + "static/media/search-icon.70fb1126.svg";